import { render, staticRenderFns } from "./TruckTrailer.vue?vue&type=template&id=07b7fcd6&"
import script from "./TruckTrailer.vue?vue&type=script&lang=js&"
export * from "./TruckTrailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports